import { FootprintShapeType } from 'data/types';
import { FootprintCommitPayload } from 'utils/footprint-shapes-commit-types';
import { isValidFootprintShape } from 'utils/footprint-union';

export function payloadFromEditedShapes(
  shapes: FootprintShapeType[]
): FootprintCommitPayload {
  const validShapes = shapes.filter((shape) =>
    isValidFootprintShape(shape.points)
  );
  if (validShapes.length === 0) {
    return { footprint: null, footprintShapes: null };
  }

  return {
    footprint: null,
    footprintShapes: validShapes.map((shape) => ({
      points: shape.points.map((point) => ({ ...point })),
      vertexEdited: shape.vertexEdited
    }))
  };
}
